// Function to check for the target container and show wrapper if found
function checkAndShowWrapper() {
    const targetContainer = document.querySelector('.tpo_option-set-container,.po-productPageOptions-root');
    const wrapperElement = document.querySelector('.ame_customization_wrapper');
    
    if (targetContainer && wrapperElement) {
        wrapperElement.style.display = 'flex'; // or 'flex', 'inline-block', etc. as needed
        console.log('Found tpo_option-set-container, showing ame_customization_wrapper');
        return true; // Found and shown
    }
    return false; // Not found yet
}

// Check immediately when script runs
if (!checkAndShowWrapper()) {
    // If not found initially, set up a MutationObserver to watch for DOM changes
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                // Check if the target container was added
                if (checkAndShowWrapper()) {
                    // Stop observing once we find and show the wrapper
                    observer.disconnect();
                }
            }
        });
    });
    
    // Start observing the document body for added nodes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}